module.exports = __webpack_public_path__ + "static/img/classBanner.5a61562.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/classBanner.png
// module id = mYC8
// module chunks = 0